/* eslint-disable no-shadow */
export enum Condition {
    OK = 'OK',
    WARNING = 'WARNING',
    DANGER = 'DANGER',
}